import React from 'react';
import { useWindowSize } from 'usehooks-ts';

import TopBanner from 'images/referral/desktop_banner.png';
import TopBannerMobile from 'images/referral/mobile_banner.png';

import { WIDTH_SM } from '../../utils/constants';
import BenefitsSection from './BenefitsSection';
import OptionsSection from './OptionsSection';
import TestimonialsSection, { Testimonial } from './TestimonialsSection';
import ValueBox from './ValueBox';
import styles from './styles.module.scss';

const SubscriptionLanding = ({ testimonials }: { testimonials: Testimonial[] }) => {
  const { width } = useWindowSize();

  return (
    <div className={styles.container}>
      <div
        className={styles.topSection}
        style={
          width > WIDTH_SM
            ? { backgroundImage: `url(${TopBanner})` }
            : { backgroundImage: `url(${TopBannerMobile})` }
        }
      >
        <ValueBox />
      </div>
      <OptionsSection />
      <BenefitsSection />
      {testimonials?.length > 0 && <TestimonialsSection testimonials={testimonials} />}
    </div>
  );
};

export default SubscriptionLanding;
